import React from 'react';

export const Type = {
  string: 'string',
  number: 'number',
  object: 'object',
  array: 'array',
};

function fromNumber(n) {
  if (typeof n === 'number') return `${n}`;
  return null;
}

function fromObject(o) {
  if (typeof o === 'object' && o !== null) return JSON.stringify(o);
  return null;
}

function fromArray(a) {
  if (Array.isArray(a)) return JSON.stringify(a);
  return null;
}

function toNumber(s) {
  const n = Number(s);
  return isNaN(n) ? null : n;
}

function toObject(s) {
  if (typeof s === 'string' && s.length > 0)
    try {
      const o = JSON.parse(s);
      if (typeof o === 'object') return o;
    } catch (e) {}
  return null;
}

function toArray(s) {
  if (typeof s === 'string' && s.length > 0) {
    try {
      const a = JSON.parse(s);
      if (Array.isArray(a)) return a;
    } catch (e) {}
  }
  return null;
}

export default class Storage {
  static set(k, v) {
    if (typeof k === 'string' && k.length > 0) {
      if (typeof v === 'number') {
        const s = fromNumber(v);
        if (s !== null) localStorage.setItem(k, s);
      } else if (Array.isArray(v)) {
        const s = fromArray(v);
        if (s !== null) localStorage.setItem(k, s);
      } else if (typeof v === 'object') {
        const s = fromObject(v);
        if (s !== null) localStorage.setItem(k, s);
      } else {
        localStorage.setItem(k, v);
      }
    }
  }

  static get(k, defaultValue = '') {
    try {
      const t = typeof defaultValue;
      if (t === 'number') {
        const n = toNumber(localStorage.getItem(k));
        if (typeof n === 'number') return n;
      } else if (t === 'object') {
        if (Array.isArray(defaultValue)) {
          const a = toArray(localStorage.getItem(k));
          if (Array.isArray(a)) return a;
        } else {
          const o = toObject(localStorage.getItem(k));
          if (typeof o === 'object' && o !== null) return o;
        }
      } else {
        return localStorage.getItem(k);
      }
    } catch (error) {}
    return defaultValue;
  }

  static rem(k) {
    if (typeof k === 'string' && k.length > 0) {
      localStorage.removeItem(k);
    }
  }

  static clear() {
    localStorage.clear();
  }
}

function typeOf(v) {
  if (Array.isArray(v)) return Type.array;
  return typeof v;
}

export function useStorage(key, initialValue) {
  const [storedValue, setStoredValue] = React.useState(() => {
    try {
      const value = Storage.get(key, typeOf(initialValue));
      return value ? JSON.parse(value) : initialValue;
    } catch (error) {
      console.warn(error);
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      Storage.set(key, valueToStore);
    } catch (error) {
      console.warn(error);
    }
  };

  return [storedValue, setValue];
}
